import { useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import { useDebounce } from 'use-debounce'

import { DEBOUNCE_DELAY, Paths } from 'constants/index'
import { GetSearchResultsQuery, useGetExternalSearchResultsLazyQuery } from 'generated/graphql'

import SearchContainer from './SearchContainer'
import SearchIcon from './SearchIcon'
import SearchResults from './SearchResults'
import StyledInputBase from './StyledInputBase'

const ExternalSearch = () => {
  const [inputValue, setInputValue] = useState<string>('')
  const [showSearchResult, setShowSearchResult] = useState<boolean>(false)

  const history = useHistory()
  const [debouncedInputValue] = useDebounce(inputValue, DEBOUNCE_DELAY)

  const [getUserSearchResult, { data, loading }] = useGetExternalSearchResultsLazyQuery({
    fetchPolicy: 'network-only',
  })

  const handleSearchChange = (e) => {
    setInputValue(e.target.value)
  }

  useEffect(() => {
    if (debouncedInputValue && debouncedInputValue.length >= 1) {
      getUserSearchResult({
        variables: { query: debouncedInputValue },
      })
    }
  }, [debouncedInputValue, getUserSearchResult])

  const handleSearchFocus = () => {
    setShowSearchResult(true)
  }

  const handleSearchBlur = () => {
    setTimeout(() => {
      setShowSearchResult(false)
    }, 200)
  }

  const handleSearchResultClick = (searchResult: GetSearchResultsQuery['searchResults'][0]) => {
    switch (searchResult.entityName) {
      case 'Booking':
        history.push(Paths.bookings.updateWithId(searchResult.entityId))
        break
      case 'BookingInvoice':
        history.push(Paths.customers.updateWithId(searchResult.entityId) + '#invoices')
        break
    }

    setInputValue('')
  }

  return (
    <SearchContainer>
      <SearchIcon />
      <StyledInputBase
        placeholder='Search…'
        inputProps={{ 'aria-label': 'search' }}
        value={inputValue}
        onChange={handleSearchChange}
        onFocus={handleSearchFocus}
        onBlur={handleSearchBlur}
      />
      {showSearchResult && inputValue && (
        <SearchResults
          debouncedInputValue={debouncedInputValue}
          searchResultsData={data?.externalSearchResults}
          loading={loading}
          onSearchResultClick={handleSearchResultClick}
        />
      )}
    </SearchContainer>
  )
}

export default ExternalSearch
